import { createContext, useReducer } from "react";

export const PhoneNumbersContext = createContext();

export const phoneNumberReducer = (state, action) => {
    switch (action.type) {
        case 'SET_PHONE_NUMBERS':
            return {
                phoneNumbers: action.payload
            }
        case 'CREATE_PHONE_NUMBER':
            return {
                phoneNumbers: [action.payload, ...state.phoneNumbers]
            }
        case 'DELETE_PHONE_NUMBER':
            return {
                phoneNumbers: state.phoneNumbers.filter((p) =>
                    p._id !== action.payload._id
                )
            }
        default: return state
    }
}

export const PhoneNumberContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(phoneNumberReducer, {
        phoneNumbers: null
    })

    return (
        <PhoneNumbersContext.Provider value={{ ...state, dispatch }}>
            {children}
        </PhoneNumbersContext.Provider>
    )
}